import { IOpenAuthModalParameters } from 'shared/types/microfrontends';

import { ensureHeaderMicrofrontend } from '../../microfrontend';

export async function openAuthModal(parameters?: IOpenAuthModalParameters): Promise<void> {
  const microfrontend = await ensureHeaderMicrofrontend();

  return microfrontend?.call('/v3/open-auth-modal/', parameters);
}
